<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      {{ domeinlijst.naam }}
    </div>

    <nav class="tabs flex flex-col sm:flex-row mx-2 border-b-2 border-gray-300">
      <button
        data-target="panel-1"
        @click="tab = 'wijzigen'"
        class="py-2 px-6 block hover:text-mi-blue-500 focus:outline-none"
        :class="{
          'border-b-2': tab == 'wijzigen',
          'border-mi-blue-500': tab == 'wijzigen',
          'font-medium': tab == 'wijzigen',
          'text-mi-blue-500': tab == 'wijzigen',
          'text-mi-blue-400': tab != 'wijzigen'
        }"
      >
        Wijzigen</button
      ><button
        data-target="panel-2"
        @click="tab = 'verwijderen'"
        class="py-2 px-6 block hover:text-mi-blue-500 focus:outline-none"
        :class="{
          'border-b-2': tab == 'verwijderen',
          'border-mi-blue-500': tab == 'verwijderen',
          'font-medium': tab == 'verwijderen',
          'text-mi-blue-500': tab == 'verwijderen',
          'text-mi-blue-400': tab != 'verwijderen'
        }"
      >
        Verwijderen
      </button>
    </nav>

    <div v-if="tab == 'wijzigen'">
      <FormulateForm
        v-model="domeinlijst_data"
        class="m-2"
        @submit="updateDomeinlijst"
      >
        <FormulateInput
          name="naam"
          type="text"
          label="Naam"
          validation="required|isUniqueName"
          :validation-messages="{
            required: 'Verplicht veld.',
            isUniqueName: 'Naam bestaat al.'
          }"
          :validation-rules="{ isUniqueName }"
        />
        <FormulateInput
          name="code"
          type="text"
          label="Code"
          validation="required|isUniqueCode|matches:/^[a-zA-Z0-9_-]+$/"
          :validation-messages="{
            required: 'Verplicht veld.',
            matches: 'Mag alleen uit getallen en/of letters of _ of - bestaan',
            isUniqueCode: 'Code bestaat al.'
          }"
          :validation-rules="{ isUniqueCode }"
        />
        <FormulateInput
          name="omschrijving"
          type="textarea"
          label="Omschrijving"
          validation="required"
          :validation-messages="{ required: 'Verplicht veld.' }"
        />
        <div class="grid grid-cols-2">
          <FormulateInput
            type="submit"
            label="Opslaan"
            input-class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
          />
          <div v-if="domeinlijst_type == 'voorziening_typen'" class="relative">
            <router-link
              :to="{
                name: 'EditFlexpropSchema',
                params: { id: domeinlijst_data.id }
              }"
              class="absolute right-0 underline pt-4 text-mi-blue-500"
              >Flexprops schema aanpassen
            </router-link>
          </div>
        </div>
      </FormulateForm>
    </div>
    <div v-if="tab == 'verwijderen'">
      <p class="m-2">
        Om te verwijderen, moet een categorie geselecteerd worden waarmee dit
        object wordt vervangen.
      </p>
      <FormulateForm
        v-model="new_domeinlijst"
        class="m-2"
        @submit="replaceDomeinlijst"
      >
        <FormulateInput
          name="id"
          type="select"
          label="Vervangende waarde"
          validation="required"
          :validation-messages="{ required: 'Verplicht veld.' }"
          :options="this.other_domeinlijst_items"
        />

        <FormulateInput
          input-class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
          type="submit"
          label="Vervangen en verwijder"
        />
      </FormulateForm>
    </div>
    <p class="text-red-600 ml-4 mb-2 mt-0">{{ msg }}</p>
  </div>
</template>

<script>
export default {
  name: "DomeinlijstCard",
  props: ["domeinlijst", "domeinlijstitems"],
  data() {
    return {
      msg: null,
      new_domeinlijst: { id: null },
      domeinlijst_data: this.domeinlijst,
      tab: "wijzigen"
    };
  },
  computed: {
    other_domeinlijst_items: function() {
      return this.domeinlijstitems
        .filter(item => item.id !== this.domeinlijst.id)
        .map(item => ({
          id: item.id,
          value: item.id,
          label: item.naam,
          naam: item.naam,
          code: item.code
        }));
    },
    other_domeinlijst_names() {
      return this.other_domeinlijst_items.map(item => item.naam);
    },
    other_domeinlijst_codes() {
      return this.other_domeinlijst_items.map(item => item.code);
    },
    domeinlijst_type() {
      return this.$route.params.name.toLowerCase();
    }
  },
  methods: {
    hideMsg: function() {
      this.msg = null;
    },
    parseResponse: function(ok, msg) {
      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
      } else {
        this.msg = msg;
      }
    },
    replaceDomeinlijst: async function() {
      const [ok, msg] = await this.$store.dispatch("replaceDomeinlijst", {
        name: this.$route.params.name.toLowerCase(),
        id: this.domeinlijst_data.id,
        id_new: this.new_domeinlijst.id
      });
      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
      } else {
        this.msg = msg;
      }
    },
    updateDomeinlijst: async function() {
      const [ok, msg] = await this.$store.dispatch("updateDomeinlijst", {
        name: this.$route.params.name.toLowerCase(),
        properties: this.domeinlijst_data
      });
      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
      } else {
        this.msg = msg;
      }
    },
    isUniqueName: function({ value }) {
      return !this.other_domeinlijst_names.includes(value);
    },
    isUniqueCode: function({ value }) {
      return !this.other_domeinlijst_codes.includes(value);
    }
  },
  watch: {
    msg() {
      if (this.msg) {
        setTimeout(this.hideMsg, 5000);
      }
    }
  }
};
</script>

<style>
.formulate-form {
  @apply font-opensans;
}

.formulate-input-wrapper {
  @apply mb-2 grid grid-cols-2;
}

.disabled {
  @apply appearance-none bg-transparent;
}

.editMode {
  @apply bg-transparent border-b border-gray-500 border-dashed;
}

.formulate-input-label {
  @apply font-bold;
}

.btn {
  @apply ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded;
}
.btn:hover {
  @apply bg-mi-blue-400 text-white border-transparent;
}

.btn.disabled {
  @apply hidden;
}
</style>
